import { useMediaQuery, useTheme } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { checkPermission, renderDate } from "../../../utils/app.utils";
import OptionsButtonCustom from "../../../components/option-button/OptionsButtonCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import moment from "moment";
import { alertActive, alertError, alertSuccess } from "../../../components/alert/swal";
import { useNavigate } from "react-router-dom";
// import { RoutePath } from "../../../routes/Routes";
import { content_news_status_data, CONTENT_TYPE, STATUS_ENUM } from "../website-structure/content/enum/content.enum";
import StatusCustom from "../../../components/status/statusCustom";
// import { renderStatus } from "../../manage-articles/enum/article.enum";
import { ContentApi, contentList } from "../../../api/content/content.api";
import SwitchCustom from "../../../components/switch/SwitchCustom";
import { RootState } from "../../../store/store";
import { routeName } from "../../../routes/routeName";
import { useTranslation } from "react-i18next";
import { CategoryApi, categoryList } from "../../../api/category/category.api";

export const ManageState = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const navigate = useNavigate();

    const profileReducer = useSelector((state: RootState) => state.profile.profile);
    const permission: any[] = profileReducer?.permission || [];
    const checkPermit = checkPermission('WEBSITE_STRUCTURE_CONTENT_NEWS', permission);


    const [content_status_name, set_content_status_name] = useState<string>("")
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [search, setSearch] = useState<string>("");
    const [data, setData] = useState<any[]>([]);
    const [startDate, setStartDate] = useState<string | null>("");
    const [endDate, setEndDate] = useState<string | null>("");
    const [search_category, set_search_category] = useState<string>("");
    const [category_data, set_category_data] = useState<any[]>([]);
    const [id_category, set_id_category] = useState<number | null>(null);

    const [id_information_source, set_id_information_source] = useState<any>(null);

    const headCell = [
        {
            id: "seq", width: 50, sortable: true, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "1", disablePadding: false, width: 200, sortable: false, align: "left", label: t("ชื่อ")
        },
        {
            id: "2", disablePadding: false, width: 150, sortable: false, align: "center", label: t("หมวดหมู่")
        },
        {
            id: "221", disablePadding: false, width: 120, sortable: false, align: "center", label: t("สถานะข่าว")
        },
        {
            id: "22", disablePadding: false, width: 80, sortable: false, align: "center", label: t("สถานะ")
        },
        {
            id: "3", disablePadding: false, width: 100, sortable: false, align: "center", label: t("ผู้สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "4", disablePadding: false, width: 90, sortable: false, align: "center", label: t("วันที่สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "action", disablePadding: false, align: "left", class: matches && data.length > 0, width: 70, label: ""
        },
    ];


    const handleChangeDateRange = (st_date: string | null, end_date: string | null) => {
        setStartDate(st_date)
        setEndDate(end_date)
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            modified_date,
            modified_by,
            created_date,
            content_name,
            status,
            content_status_name,
            // content_start_date,
            // content_start_time,
            // content_end_date,
            // content_end_time,
            id_content,
            modified_name,
            create_name,
            category_names,
            // banner_type
        } =
            objData;

        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: content_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: category_names || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: content_status_name ?
                        <StatusCustom text={t(content_news_status_data?.find((x) => x.value === content_status_name)?.label || "")}
                            type={content_news_status_data?.find((x) => x.value === content_status_name)?.value || ""} />
                        : "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: <div className="flex justify-center items-center">
                        <SwitchCustom
                            checked={status === STATUS_ENUM.ACTIVE ? true : false}
                            onChange={(st) => handleUpdateStatus(id_content, st ? STATUS_ENUM.ACTIVE : STATUS_ENUM.INACTIVE)}
                        />
                    </div>
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_name ? modified_name : create_name ? create_name : "-",
                    // label: (modified_by?.employee_name && modified_by?.employee_last_name) ? `${modified_by?.employee_name} ${modified_by?.employee_last_name}` : "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? renderDate(modified_date) : created_date ? renderDate(created_date) : "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches,
                    component:
                        <div className="flex justify-center items-center">
                            <span>
                                <OptionsButtonCustom
                                    // enableView
                                    // enableEdit
                                    // enableDelete
                                    enableView={checkPermit.isView}
                                    enableEdit={checkPermit.isUpdate}
                                    enableDelete={checkPermit.isDelete}
                                    onDeleteClick={() => handleDeleteContent(id_content)}
                                    onViewClick={() => navigate(routeName.cms_website.content_news_view.replace(":id", id_content))}
                                    onEditClick={() => navigate(routeName.cms_website.content_news_detail.replace(":id", id_content))}
                                />
                            </span>
                        </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleGetCategory = useCallback(async () => {
        let query: categoryList = {
            page: 1,
            limit: 10,
        }
        if (search_category) query.keyword = search_category
        await CategoryApi.list(query).then((res) => {
            if (res.status < 300) {
                const data_value = res.data?.data?.data?.items || [];
                set_category_data(data_value)
            }
        }).catch((err) => err)
    }, [search_category])


    const handleUpdateStatus = async (id_content: number, status: string) => {
        await ContentApi.updateStatusContent(id_content, {
            status: status
        }).then((res) => {
            if (res.status < 300) {
                handleGetData();
            }
        }).catch((err) => {
            console.log(err)
            alertError(t("อัพเดตสถานะไม่สำเร็จ"))
        })
    }
    const handleDeleteContent = (id_content: number) => {
        alertActive(t("ลบรายการ"), t("ท่านต้องการลบรายการนี้?"), undefined, undefined, async () => {
            dispatch(setLoading());
            await ContentApi.updateStatusContent(id_content, { status: STATUS_ENUM.DELETED }).then((res) => {
                if (res.status < 300) {
                    handleGetData();
                    alertSuccess(t("ลบรายการ"), t("ลบรายการ เรียบร้อย"))
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("ลบรายการ"), t("ลบรายการ ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }

    const handleGetData = useCallback(async () => {
        let query: contentList = {
            page,
            limit: pageLimit,
            sortBy,
            sortType,
            content_type: CONTENT_TYPE.NEWS
        }
        if (search) query = { ...query, keyword: search }
        if (content_status_name) query = { ...query, content_status_name: content_status_name }
        if (id_category) query.id_category = id_category;
        if (content_status_name) query.content_status_name = content_status_name
        if (startDate && endDate) query = {
            ...query,
            end_date: moment(endDate).format("YYYY-MM-DD"),
            start_date: moment(startDate).format("YYYY-MM-DD"),
        }
        dispatch(setLoading());
        await ContentApi.list(query).then((res) => {
            if (res.status < 300) {
                const data = res?.data?.data?.items || []
                setData(data)
                setTotalItems(res.data?.data?.meta?.totalItems || 0);
            }
        }).catch((err) => console.log(err)).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, id_category, content_status_name, sortBy, sortType, startDate, search, , endDate])

    useEffect(() => {
        handleGetCategory();
    }, [handleGetCategory])
    useEffect(() => {
        handleGetData();
    }, [handleGetData])

    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        handleRequestSort,
        sortBy,
        sortType,
        renderData,
        headCell,
        totalItems,
        data,
        setSearch,
        handleChangeDateRange,
        startDate,
        endDate,
        id_information_source,
        set_id_information_source,
        checkPermit,
        category_data,
        id_category,
        set_id_category,
        set_content_status_name,
        content_status_name
    }
}